import React from 'react';

const CTABanner: React.FC = () => {
  return (
    <section className="section-padding bg-black">
      <div className="container-max max-w-3xl">
        <h2 className="text-4xl md:text-5xl font-semibold text-white mb-6 leading-[1.05] tracking-[-0.02em]">
          Ready to ship AI that works in production?
        </h2>
        <p className="text-lg text-neutral-400 mb-10 leading-relaxed">
          Book a free fit call. We will check whether AI is the right tool for your problem and tell you honestly. No pitch, no obligation.
        </p>
        <a
          href="https://calendar.app.google/cnN9KoLp6WZYMX9G7"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center bg-white hover:bg-neutral-100 text-black font-medium text-base px-7 py-3.5 rounded-full transition-colors"
        >
          Book a free fit call
        </a>
      </div>
    </section>
  );
};

export default CTABanner;
